module.exports = __webpack_public_path__ + "c96a868620d28c60afd942078e287404.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/mythosgoldencity.jpg
// module id = 904
// module chunks = 0